import axios from 'axios';

export function advertiserSignupSendCode(email) {
    return axios.post(`${process.env.REACT_APP_API_URL}/advertiser/signup/send-code`, { email });
}
